import { Injectable } from "@angular/core";
import { HttpService } from "@services/http-service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { User } from "@models/user";
import { SingleResponse } from "@responses/single.response";
import { map } from "rxjs/operators";
import { UserService as UserHelperService } from "@services/user.service";
import { ManyResponse } from "@responses/many.response";
import { PaginatedResponse } from "@responses/paginated.response";
import { StoreUserRequest } from "@requests/user/store-user.request";
import { UpdateUserRequest } from "@requests/user/update-user.request";

@Injectable({
  providedIn: "root",
})
export class UserService extends HttpService {
  constructor(private http: HttpClient, private userService: UserHelperService) {
    super();
  }

  public me(): Observable<User> {
    return this.http.get<SingleResponse<User>>(`${this.apiUrl}/me`).pipe(
      map((response) => {
        this.userService.setUser(response.data);
        return response.data;
      })
    );
  }

  public search(search: string): Observable<ManyResponse<User>> {
    const params = this.prepareParams([{ key: "search", value: search }]);
    return this.http.get<ManyResponse<User>>(`${this.apiUrl}/user/search`, { params });
  }

  public index(page: number): Observable<PaginatedResponse<User>> {
    const params = this.prepareParams([{ key: "page", value: page.toString() }]);

    return this.http.get<PaginatedResponse<User>>(`${this.apiUrl}/user`, { params });
  }

  public store(request: StoreUserRequest): Observable<SingleResponse<User>> {
    return this.http.post<SingleResponse<User>>(`${this.apiUrl}/user`, request);
  }

  public delete(user: number): Observable<SingleResponse<boolean>> {
    return this.http.delete<SingleResponse<boolean>>(`${this.apiUrl}/user/${user}`);
  }

  public permanentlyDelete(user: number): Observable<SingleResponse<boolean>> {
    return this.http.delete<SingleResponse<boolean>>(`${this.apiUrl}/user/${user}/permanently`);
  }

  public restore(user: number): Observable<SingleResponse<boolean>> {
    return this.http.post<SingleResponse<boolean>>(`${this.apiUrl}/user/${user}/restore`, {});
  }

  public update(request: UpdateUserRequest, id: number): Observable<SingleResponse<User>> {
    return this.http.patch<SingleResponse<User>>(`${this.apiUrl}/user/${id}`, request);
  }

  public show(id: number): Observable<SingleResponse<User>> {
    return this.http.get<SingleResponse<User>>(`${this.apiUrl}/user/${id}`);
  }
}
